<div class="wrapper">
  <div class="candidate-profile">
    <a
      [routerLink]="['/candidates', candidate?.id]"
      class="avatar"
    >
      <common-mojo-avatar
        [id]="candidate.candidateImageId"
        [initials]="candidate.initials"
        [selectedPhotoShape]="avatarPhotoShape"
        [label]="candidate.label"
        [showLabel]="true"
        [backgroundSize]="avatarBackground"
        (click)="$event.stopPropagation()"
      >
      </common-mojo-avatar>
    </a>

    <div class="description">
      <div
        (click)="$event?.stopPropagation()"
        class="name-with-socials"
      >
        <a
          [routerLink]="['/candidates', candidate?.id]"
          class="mat-body-1 candidate-name"
          data-cy="simple-candidate-name"
        >{{ candidate?.visibleName }}</a>
      </div>

      <div class="experience-address">
        <mojo-candidate-experience
          class="card-element mat-body"
          [flexLayout]="true"
          *ngIf="candidate?.experience"
          [experience]="candidate?.experience"
          [currentJobTitle]="candidate?.currentJobTitle"
        >
        </mojo-candidate-experience>
        <mojo-candidate-address
          class="card-element mat-body grayed"
          *ngIf="candidate?.addressLong"
          [address]="candidate?.addressLong"
        >
        </mojo-candidate-address>
      </div>
      <mojo-candidate-resume-link
        class="resume-download-wrapper"
        [candidate]="candidate"
      >
      </mojo-candidate-resume-link>
    </div>
  </div>
  <mojo-candidate-resume
    class="mt-3"
    [candidate]="candidate"
    [hardSkills]="hardSkills"
    [softSkills]="softSkills"
  ></mojo-candidate-resume>
</div>
